import { gql } from '@apollo/client';

// pg_graphql uses Relay-style connections
// Strapi: data { id, attributes { ... } }
// pg_graphql: edges { node { ... } }
export const FragProductReviewItem = gql`
  fragment FragProductReviewItem on product_reviews {
    id
    product_name
    rating
    description
    updated_at
    created_at
    store_list
    taste_list
    product_review_imagesCollection {
      edges {
        node {
          id
          url
          storage_path
        }
      }
    }
    profiles {
      id
      username
      display_name
      photo_url
    }
  }
`;
